"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTypeIdCellDeps = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("../constants");
const GITHUB_CELL_DEPS_JSON_URL = 'https://raw.githubusercontent.com/ckb-cell/typeid-contract-cell-deps/main/deployment/cell-deps.json';
const CDN_GITHUB_CELL_DEPS_JSON_URL = 'https://cdn.jsdelivr.net/gh/ckb-cell/typeid-contract-cell-deps@main/deployment/cell-deps.json';
const request = (url) => axios_1.default.get(url, { timeout: 2000 });
const fetchCellDepsJson = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield Promise.any([request(GITHUB_CELL_DEPS_JSON_URL), request(CDN_GITHUB_CELL_DEPS_JSON_URL)]);
        return response.data;
    }
    catch (error) {
        // console.error('Error fetching cell deps:', error);
    }
});
const fetchTypeIdCellDeps = (isMainnet, selected, btcTestnetType) => __awaiter(void 0, void 0, void 0, function* () {
    let rgbppLockDep = (0, constants_1.getRgbppLockDep)(isMainnet, btcTestnetType);
    let btcTimeDep = (0, constants_1.getBtcTimeLockDep)(isMainnet, btcTestnetType);
    let xudtDep = (0, constants_1.getXudtDep)(isMainnet);
    let uniqueDep = (0, constants_1.getUniqueTypeDep)(isMainnet);
    const cellDepsObj = yield fetchCellDepsJson();
    if (cellDepsObj) {
        if (btcTestnetType === 'Signet') {
            rgbppLockDep = cellDepsObj.rgbpp.signet;
            btcTimeDep = cellDepsObj.btcTime.signet;
        }
        else {
            rgbppLockDep = isMainnet ? cellDepsObj.rgbpp.mainnet : cellDepsObj.rgbpp.testnet;
            btcTimeDep = isMainnet ? cellDepsObj.btcTime.mainnet : cellDepsObj.btcTime.testnet;
        }
        if (!isMainnet) {
            xudtDep = cellDepsObj.xudt.testnet;
            uniqueDep = cellDepsObj.unique.testnet;
        }
    }
    let cellDeps = [];
    if (selected.rgbpp) {
        // RGB++ config cell is deployed together with the RGB++ lock contract
        //
        // contract_deployment_transaction:
        //   - output(index=0, data=rgbpp_code)
        //   - output(index=1, data=rgbpp_config)
        //
        cellDeps = [
            ...cellDeps,
            rgbppLockDep,
            Object.assign(Object.assign({}, rgbppLockDep), { outPoint: Object.assign(Object.assign({}, rgbppLockDep.outPoint), { index: '0x1' }) }),
        ];
    }
    if (selected.btcTime) {
        // BTC Time config cell is deployed together with the BTC Time lock contract
        //
        // contract_deployment_transaction:
        //   - output(index=0, data=rgbpp_code)
        //   - output(index=1, data=rgbpp_config)
        //
        cellDeps = [
            ...cellDeps,
            btcTimeDep,
            Object.assign(Object.assign({}, btcTimeDep), { outPoint: Object.assign(Object.assign({}, btcTimeDep.outPoint), { index: '0x1' }) }),
        ];
    }
    if (selected.xudt) {
        cellDeps = [...cellDeps, xudtDep];
    }
    if (selected.unique) {
        cellDeps = [...cellDeps, uniqueDep];
    }
    return cellDeps;
});
exports.fetchTypeIdCellDeps = fetchTypeIdCellDeps;
